import {useApi} from '@/services/useApi';
import {defineStore} from 'pinia';
import {getAuthenticatedRequest} from '@/stores/AuthenticatedRequest.js';

export const useWalletStore = defineStore('wallet', {
  state: () => ({
    wallets: [],
    linkedWallets: [],
    transactions: [],
    singleWalletModal: false,
    mobileWalletSidebar: false,
    selectedAsset: '',
    selectedUserID: null,
    selectedUserName: ''
  }),
  getters: {
    getUniqueUserNames(state) {
      if (!state.linkedWallets?.length) return [];

      const usernames = new Set(
        state.linkedWallets.map(w => w.username)
      )

      const sorted = [...usernames]
        .filter(u => u.toLowerCase() !== 'engine') // حذف Engine با حساسیت به حروف
        .sort((a, b) => a.localeCompare(b, 'fa', {sensitivity: 'base'})) // مرتب‌سازی بدون حساسیت

      return ['Engine', ...sorted]
    },
    totalAmount(state) {
      const total = state.transactions.reduce((sum, item) => sum + parseFloat(item.amount), 0);
      return Number.isInteger(total) ? total : total.toFixed(2);
    }
  },
  actions: {
    openSingle(payload) {
      this.singleWalletModal = !this.singleWalletModal;
    },
    closeDetailsEmail() {
      this.singleWalletModal = false;
    },
    openMobileWalletSidebar() {
      this.mobileWalletSidebar = !this.mobileWalletSidebar;
    },
    closeMobileWalletSidebar() {
      this.mobileWalletSidebar = false;
    },
    async action_getWallets() {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 10157,
      };
      //console.log('action_getWallets Request: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_getWallets Success: ', response);
          this.wallets = response.data.wallets;
          this.linkedWallets = response.data.linkedWallets;
          return true;
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    },
    async action_getTransactions(payload) {
      this.transactions = []
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 10158,
        "wallet": {
          "transaction": payload.userID != null ? {
            "userID": payload.userID,
            "asset": payload.asset
          } : {
            "asset": payload.asset
          }
        }
      };
      //console.log('action_getTransactions Request: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_getTransactions Success: ', response);
          const transactions = response.data.wallet.transactions || []
          this.transactions = transactions.sort((a, b) => Number(b.datetime) - Number(a.datetime))
          return true;
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    },
    async action_createWallet(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 10162,
        'wallet': payload.userID ? {
          'userID': payload.userID,
          'asset': payload.asset
        } : {
          'asset': payload.asset
        }
      };
      //console.log(request)
      return await useApi(
        request,
        (response) => {
          //console.log('action_createWallet Success: ', response);
          return {
            result: true
          };
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    },
    async action_addTransactions(payload) {
      const transaction = {
        asset: payload.asset,
        amount: (payload.amount).toString(),
        title: payload.title
      };

      if (payload.userID != null && payload.userID !== '') transaction.userID = payload.userID;
      if (payload.note) transaction.note = payload.note;
      if (payload.attachment?.name) {
        transaction.attachment = {
          name: payload.attachment.name
        };
      }

      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 10159,
        "wallet": {
          transaction
        }
      };
      //console.log('action_addTransactions Request: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_addTransactions Success: ', response);
          return {
            result: true
          };
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    }
  }
});
